<template>
  <div class="quick-box">
    <p>注册成功后，登录帐号可报名参加本会组织的会议活动及会议签到等</p>
    <div class="content">
      <van-field
        v-model="params.mobile"
        class="input-item"
        left-icon="phone"
        label="手机号"
        placeholder="请输入您的手机号码"
      ></van-field>
      <div class="drag" ref="dragDiv">
          <div class="drag_bg"></div>
          <div class="drag_text">{{confirmWords}}</div>
          <div ref="moveDiv" @touchstart="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
      </div>
      <van-field class="input-item" v-model="params.code" center clearable placeholder="请输入短信验证码">
        <van-button :disabled="isDisabled" slot="button" size="small" type="primary" @click="getCode">
          <template v-if="!isSpend">发送验证码</template>
          <template v-else>( {{time}} )</template>
        </van-button>
      </van-field>
      <van-field
        class="input-item"
        :type="isShowPW?'password':''"
        left-icon="lock"
        label="密码"
        :right-icon="isShowPW?'closed-eye':'eye-o'"
        @click-right-icon="isShowPW = !isShowPW"
      v-model="params.password"
        placeholder="请输入您的登录密码"
      ></van-field>
      <van-field
        class="input-item"
        :type="isShowPW2?'password':''"
        left-icon="lock"
        label="密码"
        :right-icon="isShowPW2?'closed-eye':'eye-o'"
        @click-right-icon="isShowPW2 = !isShowPW2"
        v-model="params.password2"
        placeholder="请再次输入您的登录密码"
      ></van-field>
      <van-button class="successedBtn" type="primary" size="large" @click="submit">完成</van-button>
      <van-checkbox class="rule-box" checked-color="#228ccd" v-model="checked"  icon-size="16px">
        我已阅读
        <span @click.stop="rule">《入会须知》</span>
      </van-checkbox>
    </div>
  </div>
</template>

<script>
import { Field, Button, Checkbox, Toast } from "vant";
import {
  getRegisterCode,
  checkMobile,
  verifyRegisterCode,
  fastRegisterMember
} from "@/api/login";

export default {
  data() {
    return {
      isSpend: false,
      time: 60,
      isDisabled:false,
      params: {
        mobile: "",
        code: "",
        password: "",
        password2: ""
      },
      isShowPW: true,
      isShowPW2: true,
      checked: false,
      beginClientX:0,           /*距离屏幕左端距离*/
      mouseMoveStata:false,     /*触发拖动状态  判断*/
      maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords:'请按住滑块，拖到最右边',   /*滑块文字*/
      confirmSuccess:false           /*验证成功判断*/

    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox
  },
  methods: {
    rule() {
      this.$router.push({ name: "rule" });
    },
    async getCode() {
      let mobile = this.params.mobile;

      if (this.isSpend) {
        return;
      }

      if (!this.$regexp.mobile(mobile)) {
        Toast("请输入正确的手机号");
        return false;
      }

      await this.checkMobiles(mobile);

      getRegisterCode({ mobile }).then(res => {
        if (res.success) {
          this.isSpend = true;
          this.time = 60;
          this.count();
        }
      });
    },
    checkMobiles(mobile) {
      let params = {
        mobile
      };

      return new Promise(resolve => {
        checkMobile(params)
          .then(res => {
            if (!res.result && res.success) {
              resolve();
            } else {
              Toast.fail("该手机号码已经注册过！");
            }
          })
          .catch(() => {
            Toast.fail("该手机号码已经注册过！");
          });
      });
    },
    count() {
      --this.time;
      if (this.time > 0) {
        setTimeout(() => {
          this.count();
        }, 1000);
      } else {
        this.isSpend = false;
      }
    },
    checkCode() {
      return new Promise(resolve => {
        let code = {
          code: this.params.code
        };
        verifyRegisterCode(code).then(res => {
          if (res.success) {
            resolve();
          }
        });
      });
    },
    register() {
      let params = this.params;

      fastRegisterMember(params).then(res => {
        if (res.success) {
          Toast.success("注册成功！");
          this.$router.push({ name: "login" });
        } else {
          Toast.fail("注册失败!");
        }
      });
    },
    async submit() {
      let isMobile = this.$regexp.mobile(this.params.mobile),
        isChecked = this.$regexp.password(this.params.password),
        regexpPassword = this.$regexp.chinese(this.params.password);

      if (!this.params.mobile || !isMobile) {
        Toast("请输入正确的手机号码!");
        return;
      }

      if (!this.params.code) {
        Toast("请输入验证码!");
        return;
      }

      if (!this.params.password || !isChecked || regexpPassword) {
        Toast("密码必须为8-16为包含字母、数字、符号中至少2种且不能有空格!");
        return;
      }

      if (this.params.password !== this.params.password2) {
        Toast("两次输入的密码不正确!");
        return;
      }

      if (!this.checked) {
        Toast("请阅读入会须知！");
        return;
      }

      await this.checkCode();
      this.register();
    },
    mousedownFn:function (e) {
        if(!this.confirmSuccess){
            e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
            this.mouseMoveStata = true;
            this.beginClientX = e.changedTouches[0].clientX;
        }
    },        //mousedoen 事件
    successFunction(){
        this.confirmSuccess = true
        this.confirmWords = '验证通过';
        this.isDisabled = false;
        if(window.addEventListener){
            document.getElementsByTagName('html')[0].removeEventListener('touchmove',this.mouseMoveFn);
            document.getElementsByTagName('html')[0].removeEventListener('touchend',this.moseUpFn);
        }else {
            document.getElementsByTagName('html')[0].removeEventListener('touchend',()=>{});
        }
        document.getElementsByClassName('drag_text')[0].style.color = '#fff'
        document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
    },                //验证成功函数
    mouseMoveFn(e){
        if(this.mouseMoveStata){
            let width = e.changedTouches[0].clientX - this.beginClientX;
            if(width>0 && width<=this.maxwidth){
                document.getElementsByClassName('handler')[0].style.left = width + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
            }else if(width>this.maxwidth){
                this.successFunction();
            }
        }
    },                   //mousemove事件
    moseUpFn(e){
        this.mouseMoveStata = false;
        var width = e.changedTouches[0].clientX - this.beginClientX;
        if(width<this.maxwidth){
            document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
        }
    }                       //mouseup事件
  },
  mounted(){
      if(!this.mouseMoveStata){
        this.isDisabled = true;
      };
      this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
      document.getElementsByTagName('html')[0].addEventListener('touchmove',this.mouseMoveFn);
      document.getElementsByTagName('html')[0].addEventListener('touchend',this.moseUpFn)
  }
};
</script>

<style lang="less" scoped>
.quick-box {
  p{font-size:13px; color:#999;line-height: 20px; margin-bottom:30px; }
  h3 {
    font-size: 20px;
    font-weight: normal;
    text-align: left;
    color: #000;
  }
  .content {
    margin-top: 30px;
  }
}
.input-item {
  padding: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #efefef;

  i {
    color: #aaa;
    margin-right: 10px;
  }
  & + .input-item {
    margin-top: 30px;
  }
}
.input-sms {
  padding: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #efefef;
}
.successedBtn {
  margin-top: 40px;
  height: 45px !important; 
  line-height: 45px;
}
.rule-box {
  display: flex;
  margin-top: 20px;
  justify-content: center;
  span {
    color: #228ccd;
  }
}
.drag{
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 42px;
    font-size:15px;
    line-height: 44px;
    margin: 25px 0;
    text-align: center;
}
.handler{
    width: 40px;
    height: 40px;
    border: 1px solid #ccc;
    cursor: move;
}
.handler_bg{
    background: #fff url("../../assets/images/arroe.png") no-repeat center;
}
.handler_ok_bg{
    background: #fff url("../../assets/images/chenggong.png") no-repeat center;
}
.drag_bg{
    background-color: #7ac23c;
    height: 42px;
    width: 0px;
}
.drag_text{
    position: absolute;
    top: 0px;
    width: 100%;text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select:none;
    -ms-user-select:none;
}

</style>
